module.exports = __webpack_public_path__ + "static/media/KioskOrderCartScreen.17b9c29c.png";